import { INewMessagePayload } from 'redux/store/chatSocket/types'
import { IChatHistory } from 'redux/store/chatHistory/types'

export const parseSocketMessage = (data: INewMessagePayload): IChatHistory => ({
  ...data.payload,
  uuid: data.payload.message.uuid,
  chat_id: data.payload.chat_id,
  order_number: 0,
  read: false,
  read_by_members: false
})
